import axios from 'axios'
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'
import {getUserTempId,readToken} from '@/utils/auth'
import store from '@/store'

// 创建一个axios实例（复制出一个新的axios）
const request = axios.create({
  baseURL:'/',//基本路径
  timeout:10000, //超时时间
})


// 请求拦截器
request.interceptors.request.use((config)=>{
  // 在请求头加入一个userTempId字段，值为随机且不重复的字符串，含义是：未登录用户的身份
  config.headers.userTempId = getUserTempId()
  // 在请求头加入一个token字段，含义是用户的真实身份
  config.headers.token = readToken()
  // 进度条开始走
  nprogress.start()
  // 将本次请求的详细配置信息返回，若不返回会造成所有请求配置的丢失，最终走的是失败的回调（例子：地铁安检站）
  return config
})

// 响应拦截器
request.interceptors.response.use(
  // 响应拦截器成功的回调
  response => {
    // 进度条停止
    nprogress.done()
    // 如果code是208，证明该请求一定需要身份，但用户的身份却失效了
    if(response.data.code === 208){
      // 既然身份不合法了，就立刻触发退出登录逻辑
      store.dispatch('user/logout','身份过期，请重新登录！')
      // 终止掉后续的所有逻辑
      return new Promise(()=>{})
    }else{
      // 将服务器返回的真正数据，交给request的使用者
      return response.data
    }
  },
  error => {
    // 弹窗展示失败的原因
    alert(error.message)
    // 进度条停止
    nprogress.done()

    // 第一种做法：将错误继续传递下去
    // return Promise.reject(error.message)

    // 第二种做法：让整体流程结束
    return new Promise(()=>{})
  }
)

export default request